export default __webpack_public_path__ + "static/media/Balsting Machine.2d2e580b.jpg";